import * as React from 'react';
import { Text } from '@shared/ui-components';

import { PaymentConstants } from 'common/constants/payment';
import { Styled } from './styled';


interface Props {
  description: string;
  value: number;
  unit?: string;
}


export const  FooterRow: React.FC<Props> = ({ description, value, unit }: Props) => {
  const defaultUnit = unit ? unit : PaymentConstants.defaultCurrency;

  return (
    <Styled.FooterContainer key={description}>
      <Styled.FooterCell>
        <Styled.Description>
          <Text>{description}</Text>
        </Styled.Description>
        <Styled.Value>
          <Text>{defaultUnit}{value}</Text>
        </Styled.Value>
      </Styled.FooterCell>
    </Styled.FooterContainer>
  );
};
